/* AllFun shared coin wallet — generated from games/shared/wallet.ts by scripts/build-site-wallet.mjs. Do not edit. */
"use strict";
var AllFunWallet = (() => {
  var __defProp = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // games/shared/wallet.ts
  var wallet_exports = {};
  __export(wallet_exports, {
    ADS_LIVE: () => ADS_LIVE,
    GAME_PRICE: () => GAME_PRICE,
    GUEST_FREE_PER_DAY: () => GUEST_FREE_PER_DAY,
    INVITE_BASE: () => INVITE_BASE,
    INVITE_COINS: () => INVITE_COINS,
    LEGACY: () => LEGACY,
    MIGRATION_CAP: () => MIGRATION_CAP,
    SHARED_NOTE: () => SHARED_NOTE,
    SHARES_PER_DAY: () => SHARES_PER_DAY,
    SHARE_COINS: () => SHARE_COINS,
    SIGNUP_BONUS: () => SIGNUP_BONUS,
    SITE_WELCOME: () => SITE_WELCOME,
    TOPUP_TO: () => TOPUP_TO,
    VIDEO_COINS: () => VIDEO_COINS,
    VIDEO_GAP_MS: () => VIDEO_GAP_MS,
    WALLET_KEY: () => WALLET_KEY,
    afterWallet: () => afterWallet,
    balance: () => balance,
    bindCoins: () => bindCoins,
    cancelRun: () => cancelRun,
    captureRef: () => captureRef,
    claimShare: () => claimShare,
    claimSignup: () => claimSignup,
    claimVideo: () => claimVideo,
    claimWelcome: () => claimWelcome,
    closeRun: () => closeRun,
    earn: () => earn,
    flush: () => flush,
    freeGamesLeft: () => freeGamesLeft,
    gamePrice: () => gamePrice,
    gid: () => gid,
    incomingRef: () => incomingRef,
    inviteBonus: () => inviteBonus,
    localDay: () => localDay,
    markBegun: () => markBegun,
    migrateLegacy: () => migrateLegacy,
    mode: () => mode,
    nextPay: () => nextPay,
    noteServerBalance: () => noteServerBalance,
    onChange: () => onChange,
    openRun: () => openRun,
    payGame: () => payGame,
    paySignup: () => paySignup,
    payWelcome: () => payWelcome,
    prepareWallet: () => prepareWallet,
    previousWallet: () => previousWallet,
    readStore: () => readStore,
    ready: () => ready,
    refArrived: () => refArrived,
    referral: () => referral,
    refresh: () => refresh,
    registered: () => registered,
    requestTopup: () => requestTopup,
    resetWalletForTests: () => resetWalletForTests,
    reviveRun: () => reviveRun,
    runLost: () => runLost,
    runOf: () => runOf,
    serverUp: () => serverUp,
    settleRuns: () => settleRuns,
    sharedNoteLater: () => sharedNoteLater,
    sharesLeft: () => sharesLeft,
    shownBalance: () => shownBalance,
    signupDue: () => signupDue,
    spend: () => spend,
    spendNow: () => spendNow,
    take: () => take,
    takeSharedNote: () => takeSharedNote,
    topupStatus: () => topupStatus,
    touchRun: () => touchRun,
    videoWait: () => videoWait,
    watchCounters: () => watchCounters,
    welcomeDue: () => welcomeDue,
    welcomeSettled: () => welcomeSettled
  });

  // games/shared/ads-config.ts
  var ADS_LIVE = false;

  // games/shared/wallet.ts
  var WALLET_KEY = "allfun.wallet.v1";
  var MIGRATION_CAP = 5e3;
  var SITE_WELCOME = 800;
  var SIGNUP_BONUS = 800;
  var GAME_PRICE = 40;
  var GUEST_FREE_PER_DAY = 2;
  var TOPUP_TO = 600;
  var VIDEO_COINS = 80;
  var VIDEO_GAP_MS = 2e4;
  var SHARE_COINS = 120;
  var SHARES_PER_DAY = 3;
  var INVITE_COINS = 1e3;
  var INVITE_BASE = "https://allfun.games/?ref=";
  var SHARED_NOTE = "Coins are shared across all AllFun games";
  var AUTH_KEY = "allfun.auth.v1";
  var SYNC_KEY = "allfun.sync.v1";
  var BG_ACCOUNT_KEY = "bg.account.v1";
  var BG_WALLET_KEY = "bg.wallet.v1";
  var BG_TICKET_KEY = "bg.botTicket.v1";
  var BG_REFERRED_KEY = "bg.referredBy.v1";
  var BG_REFCODE_KEY = "bg.refcode.v1";
  var WALLET_URL = "/api/wallet";
  var HELD_MAX_MS = 2 * 60 * 1e3;
  var RUN_MAX_MS = 12 * 60 * 60 * 1e3;
  var REF_MAX_MS = 30 * 24 * 60 * 60 * 1e3;
  var BATCH = 50;
  var MAX_PENDING = 300;
  var PENDING_MAX_AGE = 7 * 24 * 60 * 60 * 1e3;
  var LEGACY = [
    { game: "basketball", key: "allfun.basketball.v1" },
    { game: "billiards", key: "allfun.billiards.v1", gift: "welcome" },
    { game: "bolts", key: "allfun.bolts.v1" },
    { game: "chefpath", key: "allfun.chefpath.v1" },
    { game: "claw", key: "allfun.claw.v1", gift: "gift" },
    { game: "dice", key: "allfun.dice.v1", gift: "gift" },
    { game: "fishing", key: "allfun.fishing.v1" },
    { game: "golf", key: "allfun.golf.v1", gift: "welcomeGift" },
    { game: "lasso", key: "allfun.lasso.v1" },
    { game: "ludo", key: "allfun.ludo.v1", gift: "gift" },
    { game: "racing", key: "allfun.racing.v1" },
    { game: "royale", key: "allfun.royale.v1", gift: "welcomeGift" },
    { game: "runner", key: "allfun.runner.v1" },
    { game: "tiles", key: "allfun.tiles.v1" },
    { game: "trivia", key: "allfun.trivia.v1" }
  ];
  function storage() {
    try {
      return typeof localStorage !== "undefined" ? localStorage : null;
    } catch (e) {
      return null;
    }
  }
  function readJson(key) {
    var _a;
    try {
      const raw = (_a = storage()) == null ? void 0 : _a.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function writeRaw(key, value) {
    try {
      const s = storage();
      if (!s) return;
      if (value === null) s.removeItem(key);
      else s.setItem(key, value);
    } catch (e) {
    }
  }
  var whole = (v) => typeof v === "number" && Number.isFinite(v) ? Math.max(0, Math.floor(v)) : 0;
  function randomId() {
    const abc = "abcdefghijkmnpqrstuvwxyz23456789";
    let out = "";
    for (let i = 0; i < 10; i += 1) out += abc[Math.floor(Math.random() * abc.length)];
    return out;
  }
  function localDay(d = /* @__PURE__ */ new Date()) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }
  var DAY_RE = /^\d{4}-\d{2}-\d{2}$/;
  var REF_RE = /^[A-Z0-9]{4,12}$/;
  var WALLET_ID_RE = /^[A-Za-z0-9-]{8,64}$/;
  function freshStore() {
    return {
      v: 1,
      gid: randomId(),
      guest: 0,
      welcomed: false,
      migrated: false,
      note: false,
      from: null,
      acct: null,
      server: null,
      srvWelcomed: null,
      srvSignup: null,
      pending: [],
      merge: null,
      linked: null,
      at: 0,
      free: { day: "", used: 0 },
      registered: false,
      runs: {},
      topDay: "",
      srvTopup: null,
      lastVideoAt: 0,
      shares: { day: "", n: 0 },
      ref: null,
      srvPrice: null,
      srvInvite: 0,
      srvWallet: null,
      memberWallet: null
    };
  }
  function readRun(r) {
    if (!r || typeof r !== "object") return null;
    const o = r;
    if (typeof o.id !== "string" || o.how !== "free" && o.how !== "coins" || o.state !== "held" && o.state !== "live" && o.state !== "lost") return null;
    return { id: o.id, spend: typeof o.spend === "string" ? o.spend : "", how: o.how, amt: whole(o.amt), acct: typeof o.acct === "string" ? o.acct : null, at: whole(o.at), state: o.state };
  }
  function readStore(raw) {
    const s = freshStore();
    if (!raw || typeof raw !== "object") return s;
    const o = raw;
    if (typeof o.gid === "string" && /^[a-z0-9]{6,20}$/.test(o.gid)) s.gid = o.gid;
    s.guest = whole(o.guest);
    s.welcomed = o.welcomed === true;
    s.migrated = o.migrated === true;
    s.note = o.note === true;
    s.from = typeof o.from === "string" ? o.from : null;
    s.acct = typeof o.acct === "string" && /^[md]:/.test(o.acct) ? o.acct : null;
    s.server = typeof o.server === "number" && Number.isFinite(o.server) ? Math.max(0, Math.floor(o.server)) : null;
    s.srvWelcomed = typeof o.srvWelcomed === "boolean" ? o.srvWelcomed : null;
    s.srvSignup = typeof o.srvSignup === "boolean" ? o.srvSignup : null;
    s.pending = Array.isArray(o.pending) ? o.pending.filter(
      (e) => !!e && typeof e === "object" && typeof e.id === "string" && typeof e.acct === "string" && (e.kind === "earn" || e.kind === "spend") && typeof e.game === "string" && typeof e.source === "string" && whole(e.amount) > 0
    ) : [];
    const m = o.merge;
    s.merge = m && typeof m === "object" && typeof m.id === "string" && typeof m.acct === "string" ? { id: m.id, acct: m.acct, amount: whole(m.amount), welcomed: m.welcomed === true } : null;
    s.linked = typeof o.linked === "string" ? o.linked : null;
    s.at = whole(o.at);
    const f = o.free;
    if (f && typeof f === "object" && typeof f.day === "string" && DAY_RE.test(f.day)) s.free = { day: f.day, used: Math.min(GUEST_FREE_PER_DAY, whole(f.used)) };
    s.registered = o.registered === true;
    if (o.runs && typeof o.runs === "object") {
      for (const [game, r2] of Object.entries(o.runs)) {
        const run = readRun(r2);
        if (run && /^[a-z]{2,16}$/.test(game)) s.runs[game] = run;
      }
    }
    s.topDay = typeof o.topDay === "string" && DAY_RE.test(o.topDay) ? o.topDay : "";
    const t = o.srvTopup;
    s.srvTopup = t && typeof t === "object" && typeof t.day === "string" ? { day: t.day, used: !!t.used, given: whole(t.given) } : null;
    s.lastVideoAt = whole(o.lastVideoAt);
    s.srvWallet = typeof o.srvWallet === "string" && WALLET_ID_RE.test(o.srvWallet) ? o.srvWallet : null;
    s.memberWallet = typeof o.memberWallet === "string" && WALLET_ID_RE.test(o.memberWallet) ? o.memberWallet : null;
    const sh = o.shares;
    if (sh && typeof sh === "object" && typeof sh.day === "string" && DAY_RE.test(sh.day)) s.shares = { day: sh.day, n: Math.min(SHARES_PER_DAY, whole(sh.n)) };
    const r = o.ref;
    s.ref = r && typeof r === "object" && typeof r.code === "string" && REF_RE.test(r.code) ? { code: r.code, at: whole(r.at) } : null;
    s.srvPrice = typeof o.srvPrice === "number" && Number.isFinite(o.srvPrice) && o.srvPrice > 0 ? Math.floor(o.srvPrice) : null;
    s.srvInvite = whole(o.srvInvite);
    return s;
  }
  var memory = null;
  function loadRaw() {
    const s = storage();
    if (!s) return memory != null ? memory : memory = freshStore();
    const raw = readJson(WALLET_KEY);
    return raw ? readStore(raw) : memory != null ? memory : freshStore();
  }
  function save(store) {
    memory = store;
    cache = null;
    writeRaw(WALLET_KEY, JSON.stringify(store));
  }
  function memberAuth() {
    const a = readJson(AUTH_KEY);
    return a && typeof a.uid === "string" && a.uid && typeof a.token === "string" && a.token ? { uid: a.uid, token: a.token } : null;
  }
  function bgAccount() {
    const a = readJson(BG_ACCOUNT_KEY);
    return a && typeof a.token === "string" && typeof a.userId === "string" ? { token: a.token, userId: a.userId } : null;
  }
  function identity() {
    const m = memberAuth();
    if (m) return { acct: `m:${m.uid}`, token: m.token, member: true, uid: m.uid };
    const d = bgAccount();
    if (d) return { acct: `d:${d.userId}`, token: d.token, member: false, uid: d.userId };
    return null;
  }
  function shownBalance(store) {
    if (store.acct === null) return store.guest;
    let base = store.server;
    if (base === null) {
      const bg = readJson(BG_WALLET_KEY);
      base = store.acct.startsWith("d:") && bg && bg.shared !== true ? whole(bg.balance) : 0;
    }
    let b = base;
    if (store.merge && store.merge.acct === store.acct) b += store.merge.amount;
    for (const e of store.pending) if (e.acct === store.acct) b += e.kind === "earn" ? e.amount : -e.amount;
    return Math.max(0, b);
  }
  function migrateLegacy(hasBgAccount) {
    let sum = 0;
    let welcomed = false;
    for (const g of LEGACY) {
      const save2 = readJson(g.key);
      if (!save2 || typeof save2 !== "object") continue;
      if (g.gift && save2[g.gift] === true) welcomed = true;
      const coins = whole(save2.coins);
      if (coins > 0) {
        sum += coins;
        writeRaw(g.key, JSON.stringify(__spreadProps(__spreadValues({}, save2), { coins: 0 })));
      }
    }
    const bg = readJson(BG_WALLET_KEY);
    if (bg && typeof bg === "object" && bg.shared !== true) {
      welcomed = true;
      if (!hasBgAccount) {
        sum += whole(bg.balance);
        writeRaw(BG_WALLET_KEY, JSON.stringify(__spreadProps(__spreadValues({}, bg), { balance: 0, shared: true })));
      }
    }
    return { coins: Math.min(MIGRATION_CAP, sum), welcomed };
  }
  function current() {
    const st = storage();
    let key = null;
    try {
      key = st ? `${st.getItem(WALLET_KEY)}${st.getItem(AUTH_KEY)}${st.getItem(BG_ACCOUNT_KEY)}` : null;
    } catch (e) {
      key = null;
    }
    if (key !== null && cache && cache.key === key) return cache.store;
    let store = loadRaw();
    const before = JSON.stringify(store);
    if (!store.migrated) {
      const moved = migrateLegacy(!!bgAccount());
      store.migrated = true;
      if (moved.welcomed) store.welcomed = true;
      store.guest += moved.coins;
    }
    store = follow(store);
    if (JSON.stringify(store) !== before) save(store);
    else if (key !== null) cache = { key, store };
    return store;
  }
  var cache = null;
  function follow(store) {
    var _a, _b, _c;
    if (((_a = store.acct) == null ? void 0 : _a.startsWith("m:")) && !memberAuth() && store.linked && store.linked.startsWith(`${store.acct.slice(2)}|`)) {
      writeRaw(BG_ACCOUNT_KEY, null);
      writeRaw(BG_TICKET_KEY, null);
      const bg = readJson(BG_WALLET_KEY);
      if (bg && typeof bg === "object") writeRaw(BG_WALLET_KEY, JSON.stringify(__spreadProps(__spreadValues({}, bg), { balance: 0, shared: true })));
      store.linked = null;
    }
    const id = identity();
    const want = (_b = id == null ? void 0 : id.acct) != null ? _b : null;
    if (id == null ? void 0 : id.member) store.registered = true;
    if (store.acct === want) return store;
    if (store.acct === null) {
      if ((store.guest > 0 || store.welcomed) && (store.from === null || want.startsWith("d:"))) {
        store.merge = { id: `${store.gid}${randomId()}`, acct: want, amount: store.guest, welcomed: store.welcomed };
      }
      store.guest = 0;
      store.from = null;
    } else if (want === null) {
      store.guest = shownBalance(store);
      store.from = store.acct.startsWith("m:") ? store.acct.slice(2) : null;
      store.welcomed = true;
      store.pending = [];
      store.merge = null;
    } else if (store.acct.startsWith("d:") && want.startsWith("m:")) {
      for (const e of store.pending) if (e.acct === store.acct) e.acct = want;
      if (((_c = store.merge) == null ? void 0 : _c.acct) === store.acct) store.merge.acct = want;
    } else {
      store.pending = store.pending.filter((e) => e.acct === want);
      store.merge = null;
    }
    store.acct = want;
    store.server = null;
    store.srvWelcomed = null;
    store.srvSignup = null;
    store.topDay = "";
    store.srvTopup = null;
    store.srvInvite = 0;
    return store;
  }
  function mutate(change) {
    const store = current();
    change(store);
    save(store);
    return store;
  }
  var listeners = /* @__PURE__ */ new Set();
  var lastShown = null;
  function notify() {
    const b = balance();
    if (b === lastShown) return;
    lastShown = b;
    for (const l of [...listeners]) {
      try {
        l(b);
      } catch (e) {
      }
    }
  }
  function onChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }
  function balance() {
    return shownBalance(current());
  }
  function mode() {
    const s = current();
    return s.acct === null ? "guest" : s.acct.startsWith("m:") ? "member" : "device";
  }
  function eventId(store) {
    return `${store.gid}.${Date.now().toString(36)}${randomId().slice(0, 4)}`;
  }
  function queue(store, e) {
    const ev = __spreadProps(__spreadValues({}, e), { id: eventId(store), acct: store.acct, at: Date.now() });
    store.pending.push(ev);
    if (store.pending.length > MAX_PENDING) store.pending.splice(0, store.pending.length - MAX_PENDING);
    return ev.id;
  }
  var clean = (game) => /^[a-z]{2,16}$/.test(game) ? game : "site";
  var cleanSource = (s) => /^[a-z][a-z0-9-]{0,23}$/.test(s) ? s : "play";
  function earn(source, amount, game, opts = {}) {
    const n = whole(amount);
    if (n <= 0) return 0;
    mutate((s) => {
      if (s.acct === null) s.guest += n;
      else queue(s, __spreadValues({ kind: "earn", game: clean(game), source: cleanSource(source), amount: n }, opts.ref ? { ref: opts.ref } : {}));
    });
    notify();
    scheduleFlush();
    return n;
  }
  function spend(reason, amount, game) {
    return take(reason, amount, game, false);
  }
  function take(reason, amount, game, clamp = true) {
    const n = whole(amount);
    if (n <= 0) return true;
    const store = current();
    if (!clamp && shownBalance(store) < n) return false;
    mutate((s) => {
      if (s.acct === null) {
        s.guest = Math.max(0, s.guest - n);
        return;
      }
      const amount2 = clamp ? Math.min(n, shownBalance(s)) : n;
      if (amount2 > 0) queue(s, __spreadValues({ kind: "spend", game: clean(game), source: cleanSource(reason), amount: amount2 }, clamp ? { clamp: true } : {}));
    });
    notify();
    scheduleFlush();
    return true;
  }
  async function spendNow(reason, amount, game) {
    return (await spendNowId(reason, amount, game)).ok;
  }
  async function spendNowId(reason, amount, game) {
    const n = whole(amount);
    if (n <= 0) return { ok: true, id: "" };
    const store = current();
    if (shownBalance(store) < n) return { ok: false, id: "" };
    if (store.acct === null) return { ok: spend(reason, n, game), id: "" };
    let id = "";
    mutate((s) => {
      id = queue(s, { kind: "spend", game: clean(game), source: cleanSource(reason), amount: n });
    });
    notify();
    const answer = await Promise.race([flushFor(id), new Promise((resolve) => setTimeout(() => resolve(null), 8e3))]);
    if (answer === null) return { ok: true, id };
    return { ok: answer.ok, id };
  }
  async function claimWelcome(game) {
    let store = current();
    if (store.acct === null) {
      if (store.welcomed) return 0;
      mutate((s) => {
        s.welcomed = true;
        s.guest += SITE_WELCOME;
      });
      notify();
      return SITE_WELCOME;
    }
    if (store.srvWelcomed === null) {
      await ready();
      store = current();
    }
    if (store.acct === null || store.srvWelcomed !== false) return 0;
    mutate((s) => {
      s.srvWelcomed = true;
      s.welcomed = true;
      queue(s, { kind: "earn", game: clean(game), source: "welcome", amount: SITE_WELCOME });
    });
    notify();
    scheduleFlush();
    return SITE_WELCOME;
  }
  async function claimSignup(game) {
    var _a, _b;
    let store = current();
    if (!((_a = store.acct) == null ? void 0 : _a.startsWith("m:"))) return 0;
    if (store.srvSignup === null) {
      await ready();
      store = current();
    }
    if (!((_b = store.acct) == null ? void 0 : _b.startsWith("m:")) || store.srvSignup !== false) return 0;
    mutate((s) => {
      s.srvSignup = true;
      queue(s, { kind: "earn", game: clean(game), source: "signup", amount: SIGNUP_BONUS });
    });
    notify();
    scheduleFlush();
    return SIGNUP_BONUS;
  }
  function welcomeDue() {
    const s = current();
    return s.acct === null ? !s.welcomed : s.srvWelcomed === false;
  }
  function welcomeSettled() {
    const s = current();
    return s.acct === null || s.srvWelcomed !== null;
  }
  function payWelcome(game) {
    if (!welcomeDue()) return 0;
    void claimWelcome(game);
    return SITE_WELCOME;
  }
  function signupDue() {
    var _a;
    const s = current();
    return !!((_a = s.acct) == null ? void 0 : _a.startsWith("m:")) && s.srvSignup === false;
  }
  function paySignup(game) {
    if (!signupDue()) return 0;
    void claimSignup(game);
    return SIGNUP_BONUS;
  }
  function afterWallet(fn) {
    const s = current();
    if (s.acct === null || s.srvWelcomed !== null && (s.srvSignup !== null || !s.acct.startsWith("m:"))) {
      fn();
      return;
    }
    void ready().then(fn, fn);
  }
  function sharedNoteLater(show, busy = () => false, delay = 1400) {
    if (current().note || typeof setTimeout !== "function") return;
    setTimeout(() => {
      if (busy() || !takeSharedNote()) return;
      show(SHARED_NOTE);
    }, delay);
  }
  function takeSharedNote() {
    const store = current();
    if (store.note) return false;
    mutate((s) => {
      s.note = true;
    });
    return true;
  }
  function prepareWallet() {
    current();
  }
  function gamePrice() {
    var _a;
    return (_a = current().srvPrice) != null ? _a : GAME_PRICE;
  }
  function gid() {
    return current().gid;
  }
  function registered() {
    return current().registered || memberAuth() !== null;
  }
  function freeGamesLeft() {
    if (registered()) return 0;
    const f = current().free;
    return Math.max(0, GUEST_FREE_PER_DAY - (f.day === localDay() ? f.used : 0));
  }
  function runOf(game) {
    var _a;
    return (_a = current().runs[clean(game)]) != null ? _a : null;
  }
  function nextPay(game, opts = {}) {
    const price = gamePrice();
    const freeLeft = opts.siteFree === false ? 0 : freeGamesLeft();
    const run = runOf(game);
    if (run && (run.state === "held" || run.state === "live")) return { how: "run", price, freeLeft };
    if (freeLeft > 0) return { how: "free", price, freeLeft };
    return { how: balance() >= price ? "coins" : "short", price, freeLeft };
  }
  var wantTopup = null;
  async function requestTopup() {
    if (mode() !== "member" || !canFetch()) return;
    wantTopup = "need";
    await flush();
    if (wantTopup) await flush();
    wantTopup = null;
  }
  async function payGame(game, opts = {}) {
    const g = clean(game);
    if (opts.siteFree !== false && freeGamesLeft() > 0) {
      const today = localDay();
      mutate((s) => {
        s.free = { day: today, used: (s.free.day === today ? s.free.used : 0) + 1 };
      });
      return { how: "free", spend: "", amt: 0 };
    }
    const price = gamePrice();
    if (current().acct === null) return spend("ticket", price, g) ? { how: "coins", spend: "", amt: price } : null;
    let paid = await spendNowId("ticket", price, g);
    if (!paid.ok && mode() === "member") {
      await requestTopup();
      paid = await spendNowId("ticket", price, g);
    }
    return paid.ok ? { how: "coins", spend: paid.id, amt: price } : null;
  }
  function openRun(game, ticket, hold = false) {
    const run = { id: randomId(), spend: ticket.spend, how: ticket.how, amt: ticket.amt, acct: current().acct, at: Date.now(), state: hold ? "held" : "live" };
    mutate((s) => {
      s.runs[clean(game)] = run;
    });
    return run;
  }
  function setRun(game, from, to) {
    const g = clean(game);
    const run = current().runs[g];
    if (!run || !from.includes(run.state)) return false;
    mutate((s) => {
      const r = s.runs[g];
      if (r) Object.assign(r, { state: to, at: Date.now() });
    });
    return true;
  }
  function markBegun(game) {
    return setRun(game, ["held", "live"], "live");
  }
  function runLost(game) {
    return setRun(game, ["live"], "lost");
  }
  function reviveRun(game) {
    return setRun(game, ["lost", "live"], "live");
  }
  function touchRun(game) {
    var _a;
    const g = clean(game);
    if (((_a = current().runs[g]) == null ? void 0 : _a.state) !== "held") return;
    mutate((s) => {
      const r = s.runs[g];
      if (r) r.at = Date.now();
    });
  }
  function closeRun(game) {
    const g = clean(game);
    if (!current().runs[g]) return;
    mutate((s) => {
      delete s.runs[g];
    });
  }
  function cancelRun(game) {
    const g = clean(game);
    const store = current();
    const run = store.runs[g];
    if (!run) return 0;
    let back = 0;
    mutate((s) => {
      delete s.runs[g];
      if (run.how === "free") {
        if (s.free.day === localDay() && s.free.used > 0) s.free.used -= 1;
      } else if (run.amt > 0 && run.acct === null && s.acct === null) {
        s.guest += run.amt;
        back = run.amt;
      }
    });
    if (run.how === "coins" && run.amt > 0 && run.acct !== null && run.acct === store.acct && run.spend) back = earn("refund", run.amt, g, { ref: run.spend });
    else notify();
    return back;
  }
  function settleRuns(now = Date.now()) {
    const runs = current().runs;
    for (const [game, run] of Object.entries(runs)) {
      if (run.state === "held" && now - run.at > HELD_MAX_MS) cancelRun(game);
      else if (run.state !== "held" && now - run.at > RUN_MAX_MS) closeRun(game);
    }
  }
  function videoWait(now = Date.now()) {
    const last = current().lastVideoAt;
    return Math.max(0, last + VIDEO_GAP_MS - now);
  }
  function claimVideo(game) {
    if (videoWait() > 0) return 0;
    mutate((s) => {
      s.lastVideoAt = Date.now();
    });
    return earn("video", VIDEO_COINS, game);
  }
  function sharesLeft() {
    const sh = current().shares;
    return Math.max(0, SHARES_PER_DAY - (sh.day === localDay() ? sh.n : 0));
  }
  function claimShare(game) {
    if (sharesLeft() <= 0) return 0;
    const today = localDay();
    mutate((s) => {
      s.shares = { day: today, n: (s.shares.day === today ? s.shares.n : 0) + 1 };
    });
    return earn("share", SHARE_COINS, game);
  }
  function previousWallet() {
    const s = current();
    if (s.memberWallet) return s.memberWallet;
    if (s.srvWallet) return s.srvWallet;
    const d = bgAccount();
    return d && WALLET_ID_RE.test(d.userId) ? d.userId : null;
  }
  function topupStatus() {
    var _a;
    const s = current();
    const member = !!((_a = s.acct) == null ? void 0 : _a.startsWith("m:"));
    const t = s.srvTopup;
    if (!member || !t || t.day !== localDay()) return { member, to: TOPUP_TO, today: "unknown", given: 0 };
    return { member, to: TOPUP_TO, today: !t.used ? "ready" : t.given > 0 ? "given" : "used", given: t.given };
  }
  function inviteBonus() {
    return current().srvInvite;
  }
  function incomingRef(now = Date.now()) {
    const r = current().ref;
    if (r && now - r.at < REF_MAX_MS) return r;
    const bg = readJson(BG_REFERRED_KEY);
    if (bg && typeof bg.code === "string" && REF_RE.test(bg.code) && now - whole(bg.at) < REF_MAX_MS) return { code: bg.code, at: whole(bg.at) };
    return null;
  }
  var arrived = null;
  function refArrived() {
    return arrived;
  }
  function captureRef(href, now = Date.now()) {
    let code = null;
    try {
      code = new URL(href).searchParams.get("ref");
    } catch (e) {
      return null;
    }
    const c = (code != null ? code : "").trim().toUpperCase();
    if (!REF_RE.test(c)) return null;
    const mine = readJson(BG_REFCODE_KEY);
    const known = incomingRef(now);
    if (c === mine || known) return known;
    const ref = { code: c, at: now };
    mutate((s) => {
      s.ref = ref;
    });
    return ref;
  }
  var inviteCache = null;
  async function referral() {
    const id = identity();
    if (!(id == null ? void 0 : id.member) || !canFetch()) return null;
    if (inviteCache && inviteCache.acct === id.acct && Date.now() - inviteCache.at < 6e4) return inviteCache.info;
    try {
      const response = await fetch("/api/invites", { headers: { authorization: `Bearer ${id.token}` }, cache: "no-store", credentials: "omit" });
      if (!response.ok) return null;
      const o = await response.json();
      if (!o || typeof o.code !== "string" || !REF_RE.test(o.code)) return null;
      const friends = Array.isArray(o.friends) ? o.friends.filter((f) => f && typeof f === "object").map((f) => {
        var _a, _b;
        return { label: String((_a = f.label) != null ? _a : ""), at: whole(f.at), coins: whole(f.coins), status: String((_b = f.status) != null ? _b : "") };
      }) : [];
      const info = { code: o.code, link: typeof o.link === "string" && /^https:\/\//.test(o.link) ? o.link : `${INVITE_BASE}${o.code}`, friends, earned: whole(o.earned), today: whole(o.today) };
      inviteCache = { at: Date.now(), acct: id.acct, info };
      return info;
    } catch (e) {
      return null;
    }
  }
  var healthCheck = null;
  function serverUp() {
    if (!canFetch() || typeof location === "undefined") return Promise.resolve(false);
    healthCheck != null ? healthCheck : healthCheck = (async () => {
      const ctl = typeof AbortController !== "undefined" ? new AbortController() : null;
      const t = ctl ? setTimeout(() => ctl.abort(), 3500) : null;
      try {
        const response = await fetch("/api/health", __spreadValues({ cache: "no-store", credentials: "omit" }, ctl ? { signal: ctl.signal } : {}));
        if (!response.ok) return false;
        const body = await response.json();
        return (body == null ? void 0 : body.ok) === true;
      } catch (e) {
        return false;
      } finally {
        if (t) clearTimeout(t);
      }
    })();
    return healthCheck;
  }
  function bindCoins(data, game, source = "play") {
    Object.defineProperty(data, "coins", {
      configurable: true,
      enumerable: false,
      get: () => balance(),
      set: (value) => {
        const next = Math.max(0, Math.floor(Number(value) || 0));
        const delta = next - balance();
        if (delta > 0) earn(source, delta, game);
        else if (delta < 0) take(source, -delta, game, true);
      }
    });
    return data;
  }
  function watchCounters(selector, format = (n) => n.toLocaleString("en-US")) {
    return onChange((b) => {
      if (typeof document === "undefined") return;
      document.querySelectorAll(selector).forEach((node) => {
        const text = format(b);
        if (node.textContent !== text) node.textContent = text;
      });
    });
  }
  var flushing = null;
  var timer = null;
  var retryMs = 0;
  var outcome = /* @__PURE__ */ new Map();
  var waiting = /* @__PURE__ */ new Map();
  var readyPromise = null;
  var readyDone = false;
  function canFetch() {
    if (typeof fetch !== "function") return false;
    if (typeof location !== "undefined" && !/^https?:$/.test(location.protocol)) return false;
    return true;
  }
  function scheduleFlush(ms = 400) {
    if (timer) return;
    timer = setTimeout(() => {
      timer = null;
      void flush();
    }, ms);
  }
  function settle(id, r) {
    var _a;
    outcome.set(id, r);
    for (const resolve of (_a = waiting.get(id)) != null ? _a : []) resolve(r);
    waiting.delete(id);
  }
  function flushFor(id) {
    const known = outcome.get(id);
    if (known) return Promise.resolve(known);
    const p = new Promise((resolve) => {
      var _a;
      const list = (_a = waiting.get(id)) != null ? _a : [];
      list.push(resolve);
      waiting.set(id, list);
    });
    void flush().then(() => {
      var _a;
      if (!outcome.has(id)) {
        for (const resolve of (_a = waiting.get(id)) != null ? _a : []) resolve(null);
        waiting.delete(id);
      }
    });
    return p;
  }
  function flush() {
    if (flushing) return flushing;
    flushing = (async () => {
      for (let round = 0; round < 8; round += 1) {
        const sent = await flushOnce();
        if (sent !== "more") break;
      }
    })().finally(() => {
      flushing = null;
    });
    return flushing;
  }
  async function flushOnce() {
    const id = identity();
    const store = current();
    if (!id || store.acct !== id.acct || !canFetch()) return "done";
    const now = Date.now();
    const events = store.pending.filter((e) => e.acct === id.acct && now - e.at < PENDING_MAX_AGE).slice(0, BATCH);
    const body = { events: events.map(({ id: eid, kind, game, source, amount, clamp, ref }) => __spreadValues(__spreadValues({ id: eid, kind, game, source, amount }, clamp ? { clamp } : {}), ref ? { ref } : {})) };
    const today = localDay();
    body.day = today;
    body.gid = store.gid;
    const topup = wantTopup != null ? wantTopup : id.member && store.topDay !== today ? "day" : null;
    if (topup) body.topup = topup;
    if (store.merge && store.merge.acct === id.acct) body.merge = { id: store.merge.id, amount: store.merge.amount, welcomed: store.merge.welcomed };
    const bg = bgAccount();
    const link = id.member && bg ? `${id.uid}|${bg.userId}` : null;
    if (link && store.linked !== link) body.device = bg.token;
    let response;
    try {
      const ctl = typeof AbortController !== "undefined" ? new AbortController() : null;
      const t = ctl ? setTimeout(() => ctl.abort(), 1e4) : null;
      try {
        response = await fetch(WALLET_URL, __spreadValues({
          method: "POST",
          headers: { authorization: `Bearer ${id.token}`, "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "omit"
        }, ctl ? { signal: ctl.signal } : {}));
      } finally {
        if (t) clearTimeout(t);
      }
    } catch (e) {
      retryLater();
      return "failed";
    }
    if (response.status === 401) {
      if (id.member) {
        writeRaw(AUTH_KEY, null);
        writeRaw(SYNC_KEY, null);
        current();
        notify();
      }
      return "failed";
    }
    if (response.status === 400 || response.status === 413) {
      mutate((s) => {
        const gone = new Set(events.map((e) => e.id));
        s.pending = s.pending.filter((e) => !gone.has(e.id));
        if (s.merge && body.merge) s.merge = null;
      });
      for (const e of events) settle(e.id, { ok: false });
      notify();
      return "more";
    }
    if (!response.ok) {
      retryLater();
      return "failed";
    }
    let answer;
    try {
      answer = await response.json();
    } catch (e) {
      retryLater();
      return "failed";
    }
    if (typeof (answer == null ? void 0 : answer.balance) !== "number" || !Array.isArray(answer.results)) {
      retryLater();
      return "failed";
    }
    retryMs = 0;
    let more = false;
    mutate((s) => {
      if (s.acct !== id.acct) return;
      const done = new Set(answer.results.map((r) => r.id));
      for (const e of events) if (now - e.at >= PENDING_MAX_AGE) done.add(e.id);
      s.pending = s.pending.filter((e) => !done.has(e.id) && !(e.acct === id.acct && now - e.at >= PENDING_MAX_AGE));
      s.server = Math.max(0, Math.floor(answer.balance));
      if (typeof answer.wallet === "string" && WALLET_ID_RE.test(answer.wallet)) {
        s.srvWallet = answer.wallet;
        if (id.member) s.memberWallet = answer.wallet;
      }
      s.srvWelcomed = answer.welcomed === true;
      if (id.member) s.srvSignup = answer.signup === true;
      if (answer.merged && s.merge && s.merge.id === answer.merged.id) s.merge = null;
      if (topup === "day") s.topDay = today;
      if (typeof answer.price === "number" && Number.isFinite(answer.price) && answer.price > 0) s.srvPrice = Math.floor(answer.price);
      const t = answer.topup;
      if (t && typeof t === "object") {
        const next = { day: typeof t.day === "string" && DAY_RE.test(t.day) ? t.day : today, used: !!t.used, given: whole(t.given) };
        const prev = s.srvTopup;
        if (next.used && next.given === 0 && prev && prev.day === next.day && prev.used && prev.given > 0) next.given = prev.given;
        s.srvTopup = next;
      }
      if (typeof answer.sharesLeft === "number" && Number.isFinite(answer.sharesLeft)) {
        const n = Math.min(SHARES_PER_DAY, Math.max(0, SHARES_PER_DAY - Math.floor(answer.sharesLeft)));
        const mine = s.shares.day === today ? s.shares.n : 0;
        s.shares = { day: today, n: Math.max(mine, n) };
      }
      if (typeof answer.videoAt === "number" && Number.isFinite(answer.videoAt) && answer.videoAt <= Date.now() + 6e4) s.lastVideoAt = Math.max(s.lastVideoAt, Math.floor(answer.videoAt));
      if (answer.invite && typeof answer.invite === "object" && whole(answer.invite.given) > 0) s.srvInvite = whole(answer.invite.given);
      if (body.device && link) {
        s.linked = link;
        if (answer.device && bg && answer.device !== bg.userId) writeRaw(BG_ACCOUNT_KEY, JSON.stringify({ token: bg.token, userId: answer.device }));
      }
      s.at = Date.now();
      more = s.pending.some((e) => e.acct === id.acct);
    });
    for (const r of answer.results) settle(r.id, { ok: r.ok });
    if (topup === "need") wantTopup = null;
    notify();
    return more ? "more" : "done";
  }
  function retryLater() {
    retryMs = Math.min(6e4, retryMs ? retryMs * 2 : 3e3);
    scheduleFlush(retryMs);
  }
  function ready(timeoutMs = 4e3) {
    if (readyDone || identity() === null || !canFetch()) return Promise.resolve();
    readyPromise != null ? readyPromise : readyPromise = flush().then(() => {
      readyDone = current().server !== null;
      readyPromise = null;
    });
    return Promise.race([readyPromise, new Promise((resolve) => setTimeout(resolve, timeoutMs))]);
  }
  function refresh() {
    readyDone = false;
    current();
    notify();
    return flush().then(() => notify());
  }
  function noteServerBalance(bgUserId, value) {
    var _a;
    const store = current();
    const mine = store.acct === `d:${bgUserId}` || ((_a = store.acct) == null ? void 0 : _a.startsWith("m:")) && store.linked === `${store.acct.slice(2)}|${bgUserId}`;
    if (!mine) return;
    mutate((s) => {
      s.server = Math.max(0, Math.floor(value));
      s.at = Date.now();
    });
    notify();
  }
  function resetWalletForTests() {
    memory = null;
    cache = null;
    listeners.clear();
    lastShown = null;
    flushing = null;
    if (timer) clearTimeout(timer);
    timer = null;
    retryMs = 0;
    outcome.clear();
    waiting.clear();
    readyPromise = null;
    readyDone = false;
    wantTopup = null;
    inviteCache = null;
    healthCheck = null;
  }
  function start() {
    var _a;
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    window.addEventListener("storage", (e) => {
      if (e.key === WALLET_KEY || e.key === null) notify();
      else if (e.key === AUTH_KEY || e.key === BG_ACCOUNT_KEY) void refresh();
    });
    window.addEventListener("online", () => void flush());
    if (typeof document !== "undefined") {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") void flush().then(() => notify());
      });
    }
    try {
      if (typeof location !== "undefined" && /[?&]ref=/.test(location.search)) {
        captureRef(location.href);
        const code = ((_a = new URL(location.href).searchParams.get("ref")) != null ? _a : "").trim().toUpperCase();
        arrived = REF_RE.test(code) ? code : null;
        if (!/\/backgammon\//.test(location.pathname) && typeof history !== "undefined") {
          const url = new URL(location.href);
          url.searchParams.delete("ref");
          history.replaceState(history.state, "", `${url.pathname}${url.search}${url.hash}`);
        }
      }
    } catch (e) {
    }
    setTimeout(() => {
      settleRuns();
      void flush().then(() => notify());
    }, 0);
  }
  start();
  return __toCommonJS(wallet_exports);
})();
